module.exports = __webpack_public_path__ + "static/media/PY.ba68d126.png";